var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('agregar-booking-planificado-modal'),_c('late-arrivals-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }